import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import Barcode from "react-barcode";

import { baseUrl, baseimgUrl, userLocation, ipAddress, userName } from '../Univ.js';

function CreateSampleid() {
    const { lab_id, ltestid } = useParams();

    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [labData, setLabData] = useState([]);
    const [labbillData, setLabBillData] = useState([]);
    const [sampleIds, setSampleIds] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        // Fetch lab data
        axios.get(`${baseUrl}lab-test-view/${ltestid}/`)
            .then(response => setLabBillData(response.data))
            .catch(error => console.error(error));

        // Fetch lab bill data
        axios.get(`${baseUrl}view-lab/${lab_id}`)
        .then(response => {
            setLabData(response.data);

            // Extract ltest_id from the fetched data
            const ltest_id = response.data[0]?.id;
            
            if (ltest_id) {
                axios.get(`${baseUrl}check-sample/${ltest_id}/${ltestid}`)
                    .then(response1 => {
                        const data = response1.data; 
                        if (data.length > 0) {
                            const hasSampleId = data.some(item => item.sampleid); // Check if any item has sampleid
                            const fetchedSampleIds = data.map(item => item.sampleid).filter(Boolean); // Extract sample IDs
            
                            setSampleIds(fetchedSampleIds); // Update state with valid sample IDs
                            setIsSubmitted(hasSampleId); // Update state based on presence of sample IDs
                        } else {
                            setSampleIds([]); // No sample IDs
                            setIsSubmitted(false); // Not submitted
                        }
                    })
                    .catch(error => console.error("Error checking sample IDs:", error));
            }
        })
        .catch(error => console.error("Error fetching lab data:", error));
       
    }, [lab_id, ltestid]);

    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const labIdFromResponse = labData[0]?.id; // Extract lab_id from labData
        if (!labIdFromResponse || !ltestid) {
            console.error("lab_id or ltestid is missing");
            Swal.fire('Error!', 'Required data is missing. Please try again.', 'error');
            return;
        }
        axios.post(`${baseUrl}get_sample_id/`)
            .then(response => {
                const sampleId = response.data.value;
                const formData = new FormData();
                formData.append('lab_id', labIdFromResponse);
                formData.append('ltestid', ltestid);
                formData.append('collect_date', selectedDateTime.toISOString().split('T')[0]);
            
                // Format time as HH:MM:SS
                const formattedTime = selectedDateTime.toTimeString().split(' ')[0]; // Get the time in HH:MM:SS format
                formData.append('collect_time', formattedTime);
                
                formData.append('sampleid', sampleId);
                formData.append("labstatus", '1');
                formData.append('printstatus', '1');
                formData.append('collectby', userName);
                formData.append('ip_add', ipAddress);
                formData.append('location', userLocation);

                axios.post(`${baseUrl}lab-sample-create/`, formData, {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        Swal.fire({
                            title: 'Lab entry has been added.',
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false
                        });

                        // Update the sample ID list and mark submission as completed
                        const updatedSampleIds = [...sampleIds, sampleId];
                        setSampleIds(updatedSampleIds);
                        setIsSubmitted(true);

                        // Save state to localStorage
                        localStorage.setItem("sampleIds", JSON.stringify(updatedSampleIds));
                        localStorage.setItem("isSubmitted", JSON.stringify(true));

                        setTimeout(() => {
                          window.location.href = `/create-sample-id/${lab_id}/${ltestid}`;
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    Swal.fire(
                        'Error!',
                        'Failed to add lab entry. Please try again later.',
                        'error'
                    );
                });
            })
            .catch(error => console.error('Error fetching sample ID:', error));
    };

    const handlePrintSampleId = () => {
    const printContents = document.getElementById('print').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    setTimeout(() => {
        window.location.reload();
    }, 1000);
    document.body.innerHTML = originalContents;
    };


    return (
        <section>
            <form>
                <div>
                    {labData.map((row, index) => (
                        <div key={index} className="table-responsive">
                            <table className="erp-table-modern">
                                <tbody>
                                    <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                        <th className="mx-0 ps-5" rowSpan="2">
                                            Name : {row.pat.patient}<br />
                                            PID : {row.pat.pat_id}<br />
                                            Consultant : Dr.{row.cons.consultant}
                                        </th>
                                    </tr>
                                    <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                        <th>
                                            Gender : {row.pat.gender}<br />
                                            Age : {row.pat.age}<br />
                                            Collect Date :
                                            <DatePicker
                                                name="collectdate"
                                                id="collectdate"
                                                selected={selectedDateTime}
                                                onChange={handleDateTimeChange}
                                                dateFormat="yyyy-MM-dd"
                                            />
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ))}
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                                <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                    <th>Sample Type</th>
                                    <th>Test</th>
                                    <th>Sample ID</th>
                                    <th>View</th>
                                </tr>
                            </thead>
                            <tbody>
                                {labbillData.map((lab, index) => (
                                    <tr key={index}>
                                        <td style={{ border: "1px solid", borderColor: "#2194d9" }}>{lab.sample}</td>
                                        <input type="hidden" name="test" id="test" value={lab.subcat?.subcat || ''} />
                                        <td style={{ border: "1px solid", borderColor: "#2194d9" }}>{lab.test}</td>
                                        <td style={{ border: "1px solid", borderColor: "#2194d9" }}>
                                            {sampleIds[index] || ''}
                                        </td>
                                        <td style={{ border: "1px solid", borderColor: "#2194d9" }}>{lab.method}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {!isSubmitted ? (
                        <button type="button" onClick={handleSubmit} className="btn btn-primary mt-4">
                            Submit
                        </button>
                    ) : (
                        <>
                        <div className="text-center mt-5" id="print">
                          <Barcode value={sampleIds} />
                          </div>

                        <button type="button" onClick={handlePrintSampleId} className="btn btn-success mt-4">
                            Print Sample ID
                        </button>
                        </>
                    )}
                </div>
            </form>
        </section>
    );
}

export default CreateSampleid;
